/**
 * services/apiUtils.js
 * ─────────────────────────────────────────────────────────────────────────────
 * Shared constants and utility functions used by all API service modules.
 *
 * EXPORTS:
 *   API_BASE_URL      — backend base URL (reads from VITE_API_BASE_URL env var)
 *   FALLBACK_IMAGE    — base64 SVG placeholder for broken ad images
 *   FALLBACK_THUMB    — base64 SVG placeholder for broken thumbnails
 *   BACKEND_HOST      — LAN host for resolving dev server media URLs
 *   resolveImageUrl   — normalises any image URL, returns fallback on failure
 *   resolveVideoUrl   — normalises video URLs to absolute LAN URLs
 *   resolveAvatarUrl  — normalises avatar/profile image URLs
 *   _isHtmlResponse   — detects accidental HTML 404 responses from the backend
 * ─────────────────────────────────────────────────────────────────────────────
 */

// ============================================================================
// API Service - Complete Implementation
// ✅ fetchAds: infinite pagination loop — follows Django's `next` URL until
//    null. No hardcoded page size limit. Works for any number of ads.
// ✅ transformAdData: real rating (no fake 3.5), strict is_liked===true,
//    price_type, condition, category_name, average_rating, rating_count
// ✅ transformAdminProductData: image_count, video_count, like_count,
//    payment_amount, payment_status, premium_plan, validity_days
// ✅ primary_video + video_thumbnail passed through for admin video UI
// ✅ adminAdjustValidity: POST to correct Django backend URL
// ✅ All admin methods: flag/unflag DMs, ad plan CRUD, notifications, follows
// ✅ transformAdData: seller_profile_image_url passed through from backend
// ✅ getSellerProfile: public endpoint fallback for ProductInfoSection avatar
// ============================================================================

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://imselling-marketplace-production.up.railway.app/api';

// ─── Shared image helpers ────────────────────────────────────────────────────
export const FALLBACK_IMAGE =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'%3E%3Crect width='400' height='300' fill='%23f0f0f0'/%3E%3Crect x='150' y='90' width='100' height='80' rx='8' fill='%23ccc'/%3E%3Ccircle cx='175' cy='115' r='12' fill='%23aaa'/%3E%3Cpolygon points='150,170 190,130 220,155 250,125 280,170' fill='%23bbb'/%3E%3Ctext x='200' y='210' font-family='Arial,sans-serif' font-size='14' fill='%23999' text-anchor='middle'%3ENo Image%3C/text%3E%3C/svg%3E";

export const FALLBACK_THUMB =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48'%3E%3Crect width='48' height='48' fill='%23f0f0f0'/%3E%3Ccircle cx='24' cy='24' r='12' fill='%23ccc'/%3E%3C/svg%3E";

export const BACKEND_HOST = 'https://imselling-marketplace-production.up.railway.app';

// ✅ Force https for Railway URLs — prevents Mixed Content warnings on imselling.shop
// Safe no-op for localhost (keeps http://127.0.0.1 intact in dev).
function _forceHttps(url) {
  if (url && url.startsWith('http://') && url.includes('railway.app')) {
    return url.replace('http://', 'https://');
  }
  return url;
}

export function resolveImageUrl(url, fallback = FALLBACK_IMAGE) {
  if (!url || typeof url !== 'string') return fallback;
  if (url.startsWith('data:'))         return url;
  if (url.startsWith('http://') || url.startsWith('https://')) return _forceHttps(url);
  const slash = url.startsWith('/') ? '' : '/';
  return _forceHttps(`${BACKEND_HOST}${slash}${url}`);
}

export function resolveVideoUrl(url) {
  if (!url || typeof url !== 'string') return null;
  if (url.startsWith('http://') || url.startsWith('https://')) return _forceHttps(url);
  const slash = url.startsWith('/') ? '' : '/';
  return _forceHttps(`${BACKEND_HOST}${slash}${url}`);
}

// ✅ Resolve any relative URL to absolute — used for profile images
export function resolveAvatarUrl(url) {
  if (!url || typeof url !== 'string') return null;
  if (url.startsWith('data:')) return url;
  if (url.startsWith('http://') || url.startsWith('https://')) return _forceHttps(url);
  const slash = url.startsWith('/') ? '' : '/';
  return _forceHttps(`${BACKEND_HOST}${slash}${url}`);
}

export function _isHtmlResponse(response) {
  const ct = response.headers.get('content-type') || '';
  return ct.includes('text/html');
}

// ─── ApiService ───────────────────────────────────────────────────────────────


























// export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://imselling-marketplace-production.up.railway.app/api';

// // ─── Shared image helpers ────────────────────────────────────────────────────
// export const FALLBACK_IMAGE =
//   "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'%3E%3Crect width='400' height='300' fill='%23f0f0f0'/%3E%3Crect x='150' y='90' width='100' height='80' rx='8' fill='%23ccc'/%3E%3Ccircle cx='175' cy='115' r='12' fill='%23aaa'/%3E%3Cpolygon points='150,170 190,130 220,155 250,125 280,170' fill='%23bbb'/%3E%3Ctext x='200' y='210' font-family='Arial,sans-serif' font-size='14' fill='%23999' text-anchor='middle'%3ENo Image%3C/text%3E%3C/svg%3E";

// export const FALLBACK_THUMB =
//   "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48'%3E%3Crect width='48' height='48' fill='%23f0f0f0'/%3E%3Ccircle cx='24' cy='24' r='12' fill='%23ccc'/%3E%3C/svg%3E";

// export const BACKEND_HOST = 'https://imselling-marketplace-production.up.railway.app';

// export function resolveImageUrl(url, fallback = FALLBACK_IMAGE) {
//   if (!url || typeof url !== 'string') return fallback;
//   if (url.startsWith('data:'))         return url;
//   if (url.startsWith('http://') || url.startsWith('https://')) return url;
//   const slash = url.startsWith('/') ? '' : '/';
//   return `${BACKEND_HOST}${slash}${url}`;
// }

// export function resolveVideoUrl(url) {
//   if (!url || typeof url !== 'string') return null;
//   if (url.startsWith('http://') || url.startsWith('https://')) return url;
//   const slash = url.startsWith('/') ? '' : '/';
//   return `${BACKEND_HOST}${slash}${url}`;
// }

// // ✅ Resolve any relative URL to absolute — used for profile images
// export function resolveAvatarUrl(url) {
//   if (!url || typeof url !== 'string') return null;
//   if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) return url;
//   const slash = url.startsWith('/') ? '' : '/';
//   return `${BACKEND_HOST}${slash}${url}`;
// }

// export function _isHtmlResponse(response) {
//   const ct = response.headers.get('content-type') || '';
//   return ct.includes('text/html');
// }

// // ─── ApiService ───────────────────────────────────────────────────────────────

